import {
  CUSTOMER_TRANSITION_SUCCESS,
  CUSTOMER_TRANSITION_LOADING,
} from '../actions/CustomerTransitionAction';

const initialState = {
  customerTransitionData: null,
  isLoading: true,
};

const CustomerTransition = (state = initialState, action = {}) => {
  switch (action.type) {
    case CUSTOMER_TRANSITION_SUCCESS:
      return {
        ...state,
        customerTransitionData: action.data,
        isLoading: false,
      };
    case CUSTOMER_TRANSITION_LOADING:
      return { ...state, isLoading: action.isLoading };

    default:
      return state;
  }
};

export default CustomerTransition;
